import DevLog from '../../devlog/Module'
import ViewportModule from '../../viewport/Module'
import PreviewModule from '../../preview/Module'
import ToolbarModule from '../../toolbar/Module'
import errorAction from '../../../actions/error/errorAction'
import transferActionProps from '../transferActionProps'
import { doPost } from '../doPost'

import { IAction, SurveyMode } from '../../../actions/types'
import { QuestionID } from '../../../questions/types'
import { ModuleID } from '../../types'
import { IErrorResponse, IRequestJumpToQuestionBody } from '../types'

import { JUMP_TO_START_OVER_ID } from '../../preview/components/const'
import { DEBUG_CLIENT } from '../const'
import { getProxyParamsFromUrl, getURLfromAction } from '../lib'
import ClientModule from '../Module'

export default async function requestJumpToQuestion(fromAction: IAction, mode: SurveyMode, target: QuestionID) {
  const resetSession = JUMP_TO_START_OVER_ID === target || !fromAction.action_url
  const body: IRequestJumpToQuestionBody = {
    device: ViewportModule.viewport.device,
    mode: mode,
    proxy_params: resetSession ? {} : fromAction.action_proxy_params || getProxyParamsFromUrl(fromAction),
    payload: ClientModule.data_values
      ? { data_values: ClientModule.data_values, name: 'change', target: target }
      : !resetSession ||
        fromAction.preview?.hard_reset ||
        fromAction.preview?.locales?.length < 2 ||
        mode == SurveyMode.RESPONDENT ||
        !ClientModule.locale
      ? { name: 'change', target }
      : { name: 'set_locale', target: ClientModule.locale }
  }

  if (DEBUG_CLIENT) {
    DevLog._log(`SW[${ModuleID.CLIENT}]:`, 'requestJumpToQuestion', body)
  }

  const resetURL = ToolbarModule.resetURL || fromAction.action_url
  const actionURL = resetSession ? resetURL : fromAction.action_url

  let nextAction = errorAction({ ...fromAction, mode })

  if (actionURL) {
    try {
      const response = await doPost<IAction | IErrorResponse>(getURLfromAction(fromAction, actionURL), body).catch(
        error => {
          DevLog.error(error, `SW[${ModuleID.CLIENT}]:`, 'requestJumpToQuestion')
          return errorAction({ ...fromAction, mode })
        }
      )
      nextAction =
        'error' === (response as IErrorResponse).status ? errorAction({ ...fromAction, mode }) : (response as IAction)
      if (!nextAction.mode) {
        nextAction.mode = mode
      }
    } catch (error) {
      DevLog.error(error, `SW[${ModuleID.CLIENT}]:`, 'requestJumpToQuestion')
    }
  } else {
    DevLog.error(new Error('no actionURL'), `SW[${ModuleID.CLIENT}]:`, 'requestJumpToQuestion', {
      action: fromAction,
      resetURL: PreviewModule.resetURL,
      resetSession
    })
  }

  return transferActionProps(fromAction, nextAction)
}
